'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Swipeable = require('./components/Swipeable.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swipeable).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-gestures-swipeable/lib/index.js
// module id = 520
// module chunks = 1